<template>
    <div class="header_nav">
        <div class="logo">
            <router-link  to="/">
                <img :src="$store.state.agentInfo.logoUrl" :alt="$store.state.agentInfo.name">
            </router-link> 
        </div>
        <div class="nav-middle"> 
            <div class="nav-text"><router-link :class="$route.name=='home'?'active':'disactive'" to="/">首页</router-link></div>
            <div class="nav-text"><router-link :class="$route.name=='recycle'?'active':'disactive'" to="/recycle">卡券回收</router-link></div>
            <div class="nav-text"><router-link :class="$route.name=='help'?'active':'disactive'" to="/help">帮助中心</router-link></div>
        </div> 
        <div class="nav-right"> 
            <!-- 改变主题颜色 -->
            <div style="margin-right: 20px;">
                <span class="choice-color">主题颜色选择</span>
                <el-color-picker size="small" v-model="themeColor" style="vertical-align: middle;" @change="changeThemeColor"></el-color-picker>
            </div>
            <template  v-if="!isLogin">
                <div class="nav-text"><router-link :class="$route.name=='login'?'active':''" to="/login">登录</router-link></div>
                <el-button size="mini" type="primary" @click="$router.push('/register')">注册</el-button>
            </template>
            <template v-else> 
                <el-dropdown>
                    <span class="el-dropdown-link" @click="$router.push('/userinfo/profile')">
                        <img src="https://image.shoukala.com/image/shoukala_new/user_icon.png" alt="">
                        个人中心
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item><router-link to="/userinfo/message">消息({{$store.state.userInfo.messageCount}})</router-link></el-dropdown-item> -->
                        <el-dropdown-item><router-link to="/userinfo/profile">账户概览</router-link></el-dropdown-item>
                        <el-dropdown-item><div @click="logoutAccount()">账户注销</div></el-dropdown-item>
                        <el-dropdown-item><router-link to="/userinfo/settings">设置</router-link></el-dropdown-item>
                        <el-dropdown-item><div @click="logout()">登出</div></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </div>
        <!-- 账户注销 -->
        <el-dialog :visible.sync="showModal" @close="showModal=false" :append-to-body="true" width="400px">
            <div slot="title" style="text-align: center;font-size: 16px;">账号注销</div>
            <div class="logout-content">
                为保证你的帐号安全，在你提交的注销申请生效前，需同时满足以下条件:
                <ul>
                    <li>
                        <span class="ul-title">帐号财产已结清</span>
                        <div class="ul-content">没有、欠款、未结清的资金和虚拟权益 本帐号及通过本帐号接入的第三方中没有未完成或存在争议的服务</div>
                    </li>
                    <li>
                        <span class="ul-title">帐号处于安全状态</span>
                        <div class="ul-content">帐号处于正常使用状态，无被盗风险</div>
                    </li>
                    <li>
                        <span class="ul-title">帐号权限解除</span>
                        <div class="ul-content">帐号已解除与其他产品的授权登陆或绑定关系</div>
                    </li>
                    <li>
                        <span class="ul-title">帐号无任何纠纷，包括投诉举报</span>
                    </li>
                </ul>
            </div>
            <p slot="footer" class="dialog-footer">
                <el-button type="default" class="modal_button" @click="showModal=false">取消</el-button>
                <el-button type="primary" @click="handleOk">确定</el-button>
            </p>
        </el-dialog>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { toLogoff } from '@/api/login.js';
export default {
    data() {
        return {
            isLogin: Cookies.get('dls_token'),
            themeColor: '',
            showModal: false
        }
    },
    created() {
        // 如果本地存在主题色从本地获取，并提交给root分发到页面进行渲染
        if(Cookies.get('themeColor')) {
            this.themeColor = Cookies.get('themeColor');
            this.$$dispatch('root','root.config',[this.themeColor,true]); // 传递数组-解决初始加载执行setThemeColor两次问题
        } else {
            this.themeColor = '#409EFF';  
        }
    },
    methods:{
        // 改变主题颜色
        changeThemeColor(value) {
            if(value) {
                this.$$dispatch('root','root.config',value);
                Cookies.set('themeColor', value, { path: '/' });
            }
        },
        // 退出登录状态
        logout(){
            Cookies.remove('dls_token')
            this.$router.push({path:'/login'})
        },
        // 账号注销
        logoutAccount() {
            this.showModal = true
        },
        // 确认注销
        handleOk() {
            toLogoff().then(res => {
                if (res.data.code === '100001') {
                    this.showModal = false
                    this.$message.success('注销成功');
                    this.logout()
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
    .header_nav {
        font-size: 14px;
        background: #fff;
        height:60px;
        width:100%;
        margin: 0 auto;
        top:0;
        padding:0 40px;
        box-sizing: border-box;
        display: flex;
        position: relative;
        z-index: 10;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #F8F8F8;
        .logo {
            img {
                width: auto;
                max-height: 60px;
            }
        }
        .nav-middle {
            flex: 1;
            display: flex;
            justify-content: center;
        }
        .active {
            color: var(--color);
        }
        .nav-text {
            margin-right: 20px;
            color: #333333;
        }
        .disactive:hover {
            color: var(--color);
        }
        .nav-right {
            display: flex;
            align-items: center;
        }   
    }

    /deep/ .el-dialog__footer {
        height: 60px;
        padding-right: 30px;
    }

    /deep/ .el-dialog__body {
        padding: 10px;
    }

    .logout-content{
        margin: 0 auto 10px;
        width: 94%;
        font-size: 16px;
        padding: 16px 5px 10px;
        color: #333333;
        li {
            padding-left: 25px;
            margin-top: 10px;
            font-size: 14px;
            .ul-title{
                font-weight: 600;
                color: #555555;
                line-height: 18px;
            }
            .ul-content{
                font-weight: 400;
                color: #999999;
                line-height: 18px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/nav.vue